var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"word"},_vm._l((_vm.word),function(letter,index){return _c('span',{key:index,staticClass:"letter",class:{ center: letter === _vm.center }},[_vm._v(_vm._s(letter))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }